import { useState } from "react";

function useArray<T extends { [a: string]: any }>(initialArray: T[] = [], idPropName: string) {
  const [array, setArray] = useState<T[]>(initialArray);

  const addItems = (items: T[]) => {
    setArray((prevArray) => {
      const result = prevArray.concat(
        items.filter((item) => prevArray.findIndex((i) => i[idPropName] === item[idPropName]) < 0)
      );
      return result;
    });
  };

  const removeItems = (ids: (string | number)[]) => {
    setArray((prevArray) =>
      prevArray.filter((item) => {
        const id = item[idPropName];
        return id && !ids.includes(id);
      })
    );
  };

  const updateItems = (updatedItems: T[]) => {
    setArray((prevArray) => {
      const newArr = [...prevArray];
      updatedItems.forEach((updatedItem) => {
        const id = updatedItem[idPropName];
        const updatedItemIndex = newArr.findIndex((item) => item[idPropName] === id);
        if (updatedItemIndex !== -1) {
          newArr[updatedItemIndex] = updatedItem;
        }
      });
      return newArr;
    });
  };

  const clearArray = () => {
    setArray([]);
  };

  return {
    array,
    updateItems,
    addItems, // Add multiple items by id
    removeItems, // Remove items by id
    clearArray,
  };
}

export default useArray;
